module.exports = __webpack_public_path__ + "static/media/img03.346afff5.webp";